import { cva, type VariantProps } from 'class-variance-authority';
import type { FC, ReactNode } from 'react';
import { cn } from '../lib/utils';

export const statusPillVariants = cva(
  'inline-flex h-6 shrink-0 items-center gap-1.5 rounded-pill border px-2.5 text-eyebrow-sm uppercase',
  {
    variants: {
      tone: {
        neutral: 'border-border-strong text-[color:var(--z-text-secondary)]',
        brand: 'border-brand-border text-brand',
        success: 'border-brand bg-brand-subtle text-brand',
        warning: 'border-warning text-warning',
        danger: 'border-[color:var(--z-danger)] text-[color:var(--z-danger-foreground)]'
      }
    },
    defaultVariants: { tone: 'neutral' }
  }
);

interface StatusPillProps extends VariantProps<typeof statusPillVariants> {
  children: ReactNode;
  className?: string;
}

/** A lifecycle state with its dot: `● DRAFT`, `● PUBLISHED`, `● ERROR`. */
export const StatusPill: FC<StatusPillProps> = ({ tone, children, className }) => (
  <span className={cn(statusPillVariants({ tone }), className)}>
    <span aria-hidden="true" className="size-1.5 rounded-full bg-current" />
    {children}
  </span>
);
